// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__VziVf","filesListContainer":"PosDisputesFiles_filesListContainer__1q9bO","filesButton":"PosDisputesFiles_filesButton__qZdbB"};